module.exports = __webpack_public_path__ + "static/img/premium_member_avatar_icon.295e2f47.png";